export const BASE_URL = "https://farm-api.dsmapps.com";
export const MAINAPIURL = "https://farm-api.dsmapps.com/api";
// export const BASE_URL = "http://localhost:8000";
// export const MAINAPIURL = "http://localhost:8000/api"; //for development
export const MAINVERSION = "1.0.0";

export const COMPANY_DETAILS = {
    name: "Agro (Pvt) Ltd",
    address: "Kaduruwela, Polonnaruwa, Sri Lanka",
    phone: "+94 37 123 4567",
    mobile: "+94 77 123 4567",
    email: "info@agro.com",
    website: "www.agro.com",
    brNo: "PV 123456"
};